import store from './store';
import { resetProjectsState } from './projectsSlice';
import { resetUserDocumentStats } from './documentsSlice';
import { resetRequestsState } from './requestsSlice';
import { resetGenerateState } from './generateSlice';

/** Clear per-user Redux data when the auth session ends or a new user logs in */
export function resetSessionReduxState() {
  const dispatch = store.dispatch;
  dispatch(resetProjectsState());
  dispatch(resetUserDocumentStats());
  dispatch(resetRequestsState());
  dispatch(resetGenerateState());
}
